import { render } from "./ChatUsers.vue?vue&type=template&id=45d6450e"
import script from "./ChatUsers.vue?vue&type=script&lang=js"
export * from "./ChatUsers.vue?vue&type=script&lang=js"
script.render = render

export default script